import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Icon from './Icon';
import type { TreeNode } from '../types';

type ClusterBreadcrumbProps = {
  pathIds?: string[];
  nodesById: Map<string, TreeNode>;
  onNavigate?: (id: string) => void;
};

export default function ClusterBreadcrumb({
  pathIds = [],
  nodesById,
  onNavigate
}: ClusterBreadcrumbProps) {
  if (!pathIds.length) {
    return (
      <Card className="mb-0">
        <Card.Body
          className="d-flex align-items-center gap-2 py-2 px-3 text-600 fs--1"
          dir="rtl"
        >
          <Icon name="signpost" className="flex-shrink-0" />
          <span>مسیر نود انتخاب‌شده اینجا نمایش داده می‌شود</span>
        </Card.Body>
      </Card>
    );
  }

  const ordered = [...pathIds].reverse();

  return (
    <Card className="mb-0">
      <Card.Body
        className="d-flex align-items-center gap-2 py-2 px-3"
        dir="rtl"
      >
        <Icon name="diagram-3" className="text-600 flex-shrink-0" />
        <nav
          className="d-flex flex-wrap align-items-center gap-1"
          aria-label="مسیر نود"
          dir="rtl"
        >
          {ordered.map((id, index) => {
            const node = nodesById.get(id);
            if (!node) return null;
            const isLast = index === ordered.length - 1;
            return (
              <span key={id} className="d-inline-flex align-items-center">
                {index > 0 ? (
                  <span
                    className="text-600 mx-1 d-inline-flex align-items-center"
                    style={{ transform: 'rotate(90deg)' }}
                  >
                    <Icon name="chevron-down" size="0.65rem" />
                  </span>
                ) : null}
                <Button
                  type="button"
                  variant="link"
                  size="sm"
                  className={`p-1 fs--1 text-decoration-none ${
                    isLast ? 'fw-bold text-primary' : 'text-800'
                  }`}
                  onClick={() => onNavigate?.(id)}
                >
                  {node.label}
                </Button>
              </span>
            );
          })}
        </nav>
      </Card.Body>
    </Card>
  );
}
